import { useEffect, useRef, useState } from 'react';
import { api } from '../lib/api';
import { useDevice } from '../store';
import { useToasts } from '../lib/toast';
import { ScanModal } from '../lib/ScanModal';
import { parseLoginQr } from '../lib/Qr';

/** Connexion staff par PIN (caisse) ou mot de passe admin (back-office) — ou par QR code. */
export function LoginGate({ mode }: { mode: 'pin' | 'admin' }) {
  const setAuth = useDevice((s) => s.setAuth);
  const push = useToasts((s) => s.push);
  const [pin, setPin] = useState('');
  const [name, setName] = useState('');
  const [pwd, setPwd] = useState('');
  const [scanOpen, setScanOpen] = useState(false);
  const busy = useRef(false);

  const submit = async () => {
    try {
      const res = mode === 'pin' ? await api.loginPin(pin) : await api.loginAdmin(name, pwd);
      setAuth(res);
      push(`Bienvenue ${res.staff.fullName}`);
    } catch (e: any) {
      push(e.message, 'warn');
      setPin('');
    }
  };

  const loginByToken = async (token: string) => {
    if (busy.current) return;
    busy.current = true;
    try {
      const res = await api.loginQr(token);
      setAuth(res);
      push(`Bienvenue ${res.staff.fullName}`);
    } catch (e: any) {
      push(e.message, 'warn');
      busy.current = false;
    }
  };

  // Douchette USB : le lecteur "tape" TAJLOGIN:<jeton> puis Entrée → connexion automatique.
  useEffect(() => {
    let buf = '', last = 0;
    let timer: ReturnType<typeof setTimeout> | undefined;
    const flush = () => { const tok = parseLoginQr(buf); buf = ''; if (tok) loginByToken(tok); };
    const onKey = (e: KeyboardEvent) => {
      const now = Date.now();
      if (now - last > 120) buf = '';
      last = now;
      if (e.key === 'Enter') {
        if (parseLoginQr(buf)) { e.preventDefault(); e.stopPropagation(); clearTimeout(timer); flush(); }
        return;
      }
      if (e.key.length === 1) { buf += e.key; clearTimeout(timer); timer = setTimeout(flush, 250); }
    };
    window.addEventListener('keydown', onKey, true);
    return () => { window.removeEventListener('keydown', onKey, true); clearTimeout(timer); };
  }, []);

  return (
    <div className="role-wrap">
      <div className="role-brand">TAJ FUSION</div>
      <div className="staff-subtitle">
        {mode === 'pin' ? 'Connexion caisse — PIN ou QR' : 'Back-office — Administrateur (ou QR)'}
      </div>
      <div style={{ maxWidth: 320, width: '100%', display: 'flex', flexDirection: 'column', gap: 12 }}>
        {mode === 'pin' ? (
          <input
            className="inp"
            type="password"
            inputMode="numeric"
            placeholder="••••"
            value={pin}
            onChange={(e) => setPin(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && submit()}
          />
        ) : (
          <>
            <input className="inp" placeholder="Nom" value={name} onChange={(e) => setName(e.target.value)} />
            <input
              className="inp"
              type="password"
              placeholder="Mot de passe"
              value={pwd}
              onChange={(e) => setPwd(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && submit()}
            />
          </>
        )}
        <button className="btn-gold" onClick={submit}>
          SE CONNECTER
        </button>

        <div style={{ display: 'flex', alignItems: 'center', gap: 10, color: 'var(--ink-faint)', fontSize: '.8rem', fontWeight: 800, margin: '2px 0' }}>
          <span style={{ flex: 1, height: 1, background: 'var(--gold-line)' }} /> OU <span style={{ flex: 1, height: 1, background: 'var(--gold-line)' }} />
        </div>
        <div style={{ textAlign: 'center', color: 'var(--ink-dim)', fontSize: '.82rem' }}>
          🔫 Scannez votre QR avec la douchette, ou :
        </div>
        <button className="linkbtn" onClick={() => setScanOpen(true)}>📷 Scanner mon QR (caméra)</button>
      </div>

      {scanOpen && (
        <ScanModal
          onScan={(text) => {
            setScanOpen(false);
            const tok = parseLoginQr(text);
            if (tok) loginByToken(tok);
            else push('QR de connexion non reconnu.', 'warn');
          }}
          onClose={() => setScanOpen(false)}
        />
      )}
    </div>
  );
}
